module.exports = __webpack_public_path__ + "img/Mask Group 2916@2x.b42a232c.png";